import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'applications',
        title    : 'Applications',
        translate: 'NAV.APPLICATIONS',
        type     : 'group',
        children : [
            {
                id       : 'dashboard',
                title    : 'Dashboard',
                type     : 'item',
                icon     : 'dashboard',
                url      : '/dashboard',
                permissions: ['view dashboards'],
            },
            {
                id       : 'accounts',
                title    : 'Contas',
                type     : 'item',
                icon     : 'groups_black',
                url      : '/accounts',
                permissions: ['view accounts'],
            },
            {
                id       : 'plans',
                title    : 'Planos',
                type     : 'item',
                icon     : 'shopping_cart_black',
                url      : '/plans',
                permissions: ['view plans'],
            },
            {
                id       : 'partners',
                title    : 'Parceiros',
                type     : 'item',
                icon     : 'groups',
                url      : '/partners',
            },
            {
                id       : 'coupons',
                title    : 'Cupons',
                type     : 'item',
                icon     : 'local_offer',
                url      : '/coupons',
                permissions: ['manage coupons'],
            },
            {
                id       : 'referral-gamification',
                title    : 'Gamificação de indicações',
                type     : 'item',
                icon     : 'card_giftcard',
                url      : '/referral-gamification',
                permissions: ['manage referral gamification'],
            },
            {
                id       : 'lead-attribution',
                title    : 'Rastreamento de leads',
                type     : 'collapsable',
                icon     : 'track_changes',
                children: [
                    {
                        id   : 'lead-attribution-leads',
                        title: 'Leads',
                        type : 'item',
                        url  : '/lead-attribution/leads',
                    },
                    {
                        id   : 'lead-attribution-report',
                        title: 'Relatório de canais',
                        type : 'item',
                        url  : '/lead-attribution/report',
                    },
                    {
                        id   : 'lead-attribution-settings',
                        title: 'Canais e regras',
                        type : 'item',
                        url  : '/lead-attribution/settings',
                        permissions: ['manage attribution'],
                    },
                ],
            },
            {
                id       : 'subscriptions',
                title    : 'Financeiro',
                type     : 'item',
                icon     : 'monetization_on',
                url      : '/payments',
                permissions: ['view subscriptions'],
            },
            {
                id       : 'blog',
                title    : 'Blog',
                type     : 'item',
                icon     : 'rss_feed',
                url      : '/blog/posts',
                permissions: ['view blogs'],
            },
            {
                id       : 'contacts',
                title    : 'Contatos',
                type     : 'item',
                icon     : 'contact_support',
                url      : '/contato-feedback',
                permissions: ['view feedbacks'],
                badge: {
                    title: '',
                    bg   : '#EC0C8E',
                    fg   : '#FFFFFF'
                },
            },
            {
                id       : 'notification',
                title    : 'Notificações',
                type     : 'item',
                icon     : 'notifications',
                url      : '/notifications',
                permissions: ['view notifications'],
            },
            {
                id       : 'alert',
                title    : 'Alertas',
                type     : 'item',
                icon     : 'warning_black',
                url      : '/alerts',
                permissions: ['view alerts'],
            },
            {
                id       : 'push-campaign',
                title    : 'Disparo Push',
                type     : 'item',
                icon     : 'campaign',
                url      : '/push-campaigns',
                permissions: ['push view campaigns'],
            },
            // {
            //     id       : 'whatsapp',
            //     title    : 'Whatsapp',
            //     type     : 'item',
            //     icon     : 'whatsapp',
            //     url      : '/whatsapp',
            //     svgIcon  : 'whatsapp'
            //     // permissions: ['view whatsapp'],
            // },
            {
                id       : 'nps',
                title    : 'NPS',
                type     : 'item',
                icon     : 'star',
                url      : '/nps',
            },
            {
                id       : 'churn',
                title    : 'Churn',
                type     : 'item',
                icon     : 'trending_down',
                url      : '/churn',
                permissions: ['view churn'],
            },
            {
                id       : 'bi',
                title    : 'Indicadores',
                type     : 'item',
                icon     : 'insights',
                url      : '/bi',
                permissions: ['view churn'],
            },
            {
                id       : 'clusterizacao-uso-funcionalidade',
                title    : 'Cruzamento de indicadores',
                type     : 'item',
                icon     : 'scatter_plot',
                url      : '/clusterizacao/uso-funcionalidade',
                permissions: ['view clustering'],
            },
            {
                id       : 'clusterizacao-personas',
                title    : 'Personas',
                type     : 'item',
                icon     : 'groups',
                url      : '/clusterizacao/personas',
                permissions: ['view clustering'],
            },
        ]

    },

    {
        id: 'admin',
        title: 'Administração',
        type: 'group',
        permissions: ['view settings'],
        children: [
            // {
            //     id: 'configurations',
            //     title: 'Configurações',
            //     type: 'collapsable',
            //     icon: 'settings',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'Contatos',
            //             type: 'item',
            //             icon: 'question_answer_black',
            //             url: '/settings/common',
            //             permissions: ['view contacts'],
            //         },
            //         {
            //             id: 'documents',
            //             title: 'Documentos Legais',
            //             type: 'item',
            //             url: '/settings/documents',
            //             permissions: ['view documents'],
            //         },
            //     ]
            // },
            {
                id: 'global-settings',
                title: 'Configuracoes Globais',
                type: 'item',
                icon: 'settings',
                url: '/settings/global',
                permissions: ['view settings'],
            },
            {
                id       : 'cards',
                title    : 'Cards',
                type     : 'item',
                icon     : 'dashboard_customize',
                url      : '/cards',
                permissions: ['view cards'],
            },
            {
                id       : 'faqs',
                title    : 'FAQ',
                type     : 'collapsable',
                icon     : 'help',
                permissions: ['view faqs'],
                children: [
                    {
                        id: 'common',
                        title: 'Perguntas e Respostas',
                        type: 'item',
                        url: '/faqs',
                        permissions: ['view faqs'],
                        // icon     : 'help',
                    },
                    {
                        id       : 'faq_categories',
                        title    : 'Categoria de FAQ',
                        type     : 'item',
                        // icon     : 'help',
                        url      : '/faq-categories',
                        permissions: ['view faq_categories'],
                    },

                ],
            },
            {
                id: 'users',
                title: 'Usuários',
                type: 'item',
                icon: 'vpn_key',
                url: '/users',
                permissions: ['view users'],
            },
            {
                id: 'roles',
                title: 'Perfis Administrativos',
                type: 'item',
                icon: 'admin_panel_settings',
                url: '/roles',
                permissions: ['manage role permissions'],
            },
        ]
    },{
        id: 'admin',
        title: 'Sistema',
        type: 'group',
        permissions: ['view settings'],
        children: [
            {
                id       : 'logs-acao',
                title    : 'Logs de ação',
                type     : 'item',
                icon     : 'speaker_notes_black',
                url      : '/logs-errors',
                permissions: ['view logs'],
            },
            {
                id       : 'upload-file',
                title    : 'Arquivos',
                type     : 'item',
                icon     : 'folder',
                url      : '/upload-file',
                permissions: ['view files'],
            }
        ]
    }
];
